import React from 'react';
import './src/styles/global.scss';
import { CookiesProvider } from 'react-cookie';

export const wrapRootElement = ({ element }) => (
  <CookiesProvider>{element}</CookiesProvider>
)
